import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {setActiveTabAction} from '../../QCTabs/Redux/QCTabsActions';
import {TabIndex} from '../../QCTabs/QCTabsTypes';
import {
    setMarkupAction,
    resetMarkupAction,
} from './Redux/MarkupActions';
import MarkerRowContainer from '../MarkerRow/MarkerRowContainer';
import {
    toggleSelectedMarkerAction,
    toggleSelectedRowAction,
} from '../Redux/TimelineActions';
import {TimelineState} from '../Redux/TimelineReducer';
import {
    TimelineRow,
    TimelineMarker,
    TimelineRowType,
} from '../TimelineTypes';
import {MarkupState} from './Redux/MarkupReducer';

interface TimelineStore {
    selectedMarker: TimelineState;
    markup: MarkupState;
}

export interface State {
    timeline: TimelineStore;
}

interface StateProps {
    markerRowData: TimelineRow;
    selectedRowId: string;
    selectedMarkerId: string;
    tabIndex: TabIndex;
}

export const selectMarkerRow = (markers: TimelineMarker[], label: string, identifier: string): TimelineRow => {
    const type = TimelineRowType.Markup;
    
    return {
        markers,
        label,
        identifier,
        type,
    };
};

const getRow = (row: TimelineRow): TimelineRow => row;

export const markupTrackSelector = createSelector(selectMarkerRow, getRow);

export const label = 'Markup';

export const mapState = (state: State): StateProps => {
    const {timeline} = state;
    const {selectedMarker, markup} = timeline;
    const {markers, rowId} = markup;
    const {
        selectedRowId,
        selectedMarkerId,
    } = selectedMarker;
    
    const markerRowData = markupTrackSelector(markers, label, rowId);
    
    return {
        markerRowData,
        selectedRowId,
        selectedMarkerId,
        tabIndex: TabIndex.Markup,
    };
};

export const mapDispatch = {
    setMarkers: setMarkupAction,
    resetMarkers: resetMarkupAction,
    toggleSelectedMarker: toggleSelectedMarkerAction,
    toggleSelectedRow: toggleSelectedRowAction,
    setActiveTab: setActiveTabAction,
};

export default connect(mapState, mapDispatch)(MarkerRowContainer);
